import React from 'react';
import styled from 'styled-components'
import {
    SuggestionHoverColor,
    SuggestionHoverColorActive,
    WerfenColor,
    White
} from '../../../../Constants/ColorChart'

/*
 *  @Description:   Stateless component that renders a Filter.
 */

const StyledFilter = styled.button`
    direction: ltr;
	background-color: transparent;
    border: 1px solid ${ props => props.color ? props.color : WerfenColor };
    border-radius: 0;
    color: ${ props => props.color ? props.color : WerfenColor };
    font-size: 14px;
    padding: 5px 29px;
    text-decoration: none;
    box-sizing: border-box;
	white-space: nowrap
    position: relative;
    margin: 4px;
    font-family: Roboto,sans-serif;
    font-weight: 400;
    line-height: 24px;
    outline:none;

    &:hover{
        @media(hover:hover){
            color: ${ White };
            background-color: ${ SuggestionHoverColor };
            border-color: ${ SuggestionHoverColor };
        }
    }
    &.active{
            color: ${ White };
    	background-color: ${ props => props.color ? props.color : WerfenColor };
        cursor: pointer;
        &:hover{
            @media(hover:hover){
            color: ${ White };
                background-color: ${ SuggestionHoverColorActive };
                border-color: ${ SuggestionHoverColorActive };
            }
        }
    }
    transition: all 300ms;
	
`;
const StyledSpan = styled.span`
    .fullText { 
        margin-right: 5px; 
        display: inline;
    }
`;


const FilterItem = ( { color, text, origin, onClick, active, value } ) => {
    return (
        <StyledFilter
            value={ value }
            color={ color }
            onClick={ onClick }
            className={ (active ? "active searchElement " : "searchElement ") + origin }
        >
            <StyledSpan>
                <span className={ "fullText " + origin }>{ text }</span>
            </StyledSpan>
        </StyledFilter>
    )
};

export default FilterItem;